import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, } from '@angular/common/http';
import { AppConfig } from '../app-config';

// models
import { SchoolData } from 'src/app/models/schoolUser';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  public schoolProps!: SchoolData;

  constructor(
    private httpClient: HttpClient,
    private apiUrl: AppConfig
  ) { }

  public getSchoolAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.groupApiUrl.getSchoolAPI, { params: filterData });
  }
  public removeSchoolAPI = (schoolID: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.groupApiUrl.removeSchoolAPI, schoolID);
  }
  public getTeacherAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.groupApiUrl.getTeacherAPI, { params: filterData });
  }
  public removeTeacherAPI = (teacherID: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.groupApiUrl.removeTeacherAPI, teacherID);
  }
  public WaggaupdateValidationAPI = (requestData: any, teacherID: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.groupApiUrl.WaggaupdateValidationAPI + teacherID + '/', requestData);
  }
  public BceupdateValidationAPI = (requestData: any, teacherID: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.groupApiUrl.BceupdateValidationAPI + teacherID + '/', requestData);
  }

  public getLappsedAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.groupApiUrl.getLappsedAPI, { params: filterData });
  }
  public getLappsedApprovedAPI = (requestData: any,): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.groupApiUrl.getLappsedApprovedAPI, requestData);
  }


  public getBookingsReportAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.groupApiUrl.getBookingsReportAPI, { params: filterData });
  }
  public getBookingsDownloadReportAPI = (requestData: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.groupApiUrl.getBookingsReportAPI, requestData);
  }

  public getCustomFieldAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.groupApiUrl.getCustomFieldAPI, { params: filterData });
  }

  public bookingsReportPageAPI = (requestData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.groupApiUrl.bookingsReportPageAPI, { params: requestData });
  }
  public bookingsPreConfirmReportPageAPI = (requestData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.groupApiUrl.bookingsPreConfirmReportPageAPI, { params: requestData });
  }
  public validatedTeachersGraphAPI = (requestData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.groupApiUrl.validatedTeachersGraphAPI, { params: requestData });
  }
  public schoolEducatorsGraphAPI = (requestData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.groupApiUrl.schoolEducatorsGraphAPI, { params: requestData });
  }
  public schoolListGraphAPI = (requestData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.groupApiUrl.schoolListGraphAPI, { params: requestData });
  }

  public pendingInviteAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.groupApiUrl.pendingInviteAPI, { params: filterData });
  }
  public pendingRequestAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.groupApiUrl.pendingRequestAPI, { params: filterData });
  }
  public personalInfoAPI = (): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.groupApiUrl.personalInfoAPI);
  }
  personalInfoUpdateAPI = (requestData: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.groupApiUrl.personalInfoAPI, requestData);
  }
  public getRequestApprovedAPI = (requestData: any,): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.groupApiUrl.getRequestApprovedAPI, requestData);
  }
  public CDMNupdateValidationAPI = (requestData: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.groupApiUrl.CDMNupdateValidationAPI, requestData);
  }
  public suspendTeacherAPI = (filterData: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.groupApiUrl.suspendTeacherAPI, filterData);
  }
  
  public CairnsupdateValidationAPI = (requestData: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.groupApiUrl.CairnsupdateValidationAPI, requestData);
  }

}
